<template>
  <svg
    class="iconLinkedin"
    :width="width"
    :height="height"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7278 10.2085C11.7841 10.2085 10.2084 11.7842 10.2084 13.7279V56.2723C10.2084 58.216 11.7841 59.7917 13.7278 59.7917H56.2723C58.216 59.7917 59.7917 58.216 59.7917 56.2723V13.7279C59.7917 11.7842 58.216 10.2085 56.2723 10.2085H13.7278ZM21.3376 25.6066C23.7131 25.6066 25.6389 23.6808 25.6389 21.3053C25.6389 18.9297 23.7131 17.0039 21.3376 17.0039C18.962 17.0039 17.0362 18.9297 17.0362 21.3053C17.0362 23.6808 18.962 25.6066 21.3376 25.6066ZM29.5782 28.7854H36.7069V32.0511C36.7069 32.0511 38.6414 28.1822 43.9048 28.1822C48.6 28.1822 52.4895 30.4952 52.4895 37.5453V52.412H45.1021V39.3467C45.1021 35.1878 42.8818 34.7304 41.1898 34.7304C37.6785 34.7304 37.0774 37.7591 37.0774 39.8892V52.412H29.5782V28.7854ZM25.0872 28.7855H17.588V52.412H25.0872V28.7855Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "email",
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: "#FFC56E",
    },
  },
};
</script>
